// @flow

import React, { type Element } from 'react'
import { TextField, Box, Typography, Checkbox, FormControlLabel, Link } from '@material-ui/core'
import type { Speciality } from '../../types'
import { grey } from '@material-ui/core/colors'

type Props = {|
  speciality: Speciality,
  setSpeciality: (Speciality) => void,
  gimTraining: boolean,
  setGimTraining: (boolean) => void,
  specialityList: Array<Speciality>,
  error: string,
|}

function SpecialitySelect({
  speciality,
  setSpeciality,
  gimTraining,
  setGimTraining,
  specialityList,
  error,
}: Props): Element<typeof React.Fragment> {
  const handleSpecialityChange = (event: SyntheticInputEvent<HTMLInputElement>): void => {
    const value = parseInt(event.target.value, 10)
    const newSpeciality: Speciality | void = specialityList.find((speciality) => {
      return speciality.id === value
    })
    if (newSpeciality) setSpeciality(newSpeciality)
  }

  const handleGimCheckboxChange = (): void => {
    setGimTraining(!gimTraining)
  }

  const INTERNAL_MEDICINE_SPECIALITY_ID = 15

  return (
    <Box py={2}>
      <TextField
        id="speciality-select"
        select
        label="Speciality"
        variant="outlined"
        fullWidth
        error={error !== ''}
        helperText={error ? 'Speciality ' + error : error}
        value={speciality.id}
        onChange={handleSpecialityChange}
        SelectProps={{
          native: true,
        }}
      >
        {specialityList.map((speciality) => (
          <option key={speciality.id} value={speciality.id}>
            {speciality.title}
          </option>
        ))}
      </TextField>
      {speciality.id === INTERNAL_MEDICINE_SPECIALITY_ID && (
        <Box border={1} borderRadius={8} p={1.5} mt={2} color={grey[300]}>
          <Box fontWeight="fontWeightBold" mb={1} color={grey[600]}>
            Have you completed 3 years of core Internal Medicine training, plus at least 1 full year
            of General Internal Medicine training?
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={gimTraining}
                onChange={handleGimCheckboxChange}
                color="primary"
                data-testid="gim_checkbox"
              />
            }
            label={
              <Typography>
                Yes - I qualify for the new GIM codes, effective Oct 1st 2018.
              </Typography>
            }
          />
          <Box ml="auto" display="flex" justifyContent="flex-end">
            <Link
              href="https://www.dr-bill.ca/blog/general-internal-medicine-gim-new-fees-codes"
              rel="noopener noreferrer"
              target="_blank"
            >
              Learn more
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default SpecialitySelect
